import type { Options } from "ky";

import { postJson } from "#app/lib/fetchClient";

import { GATEWAY_PATHS } from "../api-utils";
import type { MfaResult } from "./model-types";

type PostChallengeCompleteParams = {
  JWT?: string | null | undefined;
  AuthVendorJwt?: string | null | undefined;
};

type PostChallengeCompleteData = MfaResult;

export async function postChallengeComplete(
  params: PostChallengeCompleteParams & Pick<Options, "signal">,
): Promise<PostChallengeCompleteData> {
  // Call endpoint
  const data = await postJson<PostChallengeCompleteData>(
    `${GATEWAY_PATHS.bolAuthenticationService}/Challenge/Complete`,
    {
      headers: {
        JWT: params.JWT ?? "",
        AuthVendorJwt: params.AuthVendorJwt ?? "",
      },
      json: {},
      signal: params.signal,
    },
    true,
  );

  // Success
  return data;
}
